import { Input, Label } from '@virtual-care/shadcn';
import { FieldMessage } from '@virtual-care/ui';

export function PhoneField<
  TF extends {
    state: any;
    handleChange: (value: string) => void;
    handleBlur: () => void;
  },
>({ field }: { field: TF }) {
  return (
    <div className="space-y-2">
      <Label htmlFor="phoneNumber">Phone</Label>
      <Input
        id="phoneNumber"
        type="tel"
        placeholder="+966XXXXXXXXX"
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
      />
      <FieldMessage errors={field.state.meta.errors} />
    </div>
  );
}
